var getScope = function (widgetId) {
	return angular.element($('#' + widgetId + '_widget')).scope();
};

angular
	.module('dcApp')
	.directive('datablock', [
		'$parse',
		'$compile',
		'$timeout',
		'dataBlockControlerGenerator',
		function ($parse, $compile, $timeout, dataBlockControlerGenerator) {
			var controller = dataBlockControlerGenerator.getController();

			return {
				restrict: 'E',

				scope: {
					widget: '=',
					autoExecute: '=',
					enableFilter: '=',
					enableDuplicate: '=',
					disableEntiteStatus: '=',
					enableMove: '=',
					enableFormules: '=',
					enableAddColumn: '=',
					enableHistoric: '=',
					enableEntiteRebound: '=',
					enableGeolocalisation: '=',
					disableAgregation: '=',
					enableDataBlockLinks: '=',
					widgetData: '=',
					disableMenu: '=',
				},
				controller: controller,
				controllerAs: 'vm',
				bindToController: true,
				templateUrl: './src/components/directives/dataBlock/dataBlock.html',
				link: function (scope, element, attrs, $ctrl) {
					scope.jobDetails = { rerunMethod: scope.execWithoutCache };
					scope.jobDetailsId = generateUuid('_');
					scope.uuid = generateUuid('_');
					scope.isLinearGaugeLoaded = true;

					if ($ctrl.widget.globalSearchTextIgnoreCase === undefined) {
						$ctrl.widget.globalSearchTextIgnoreCase = true;
					}

					if (!$ctrl.widget.process_data && !$ctrl.widget.process_count) {
						$ctrl.widget.process_data = $ctrl.widget.process_count = true;
					}
					$ctrl.widget.process_summary = true;
					$ctrl.widget.reloadWidget = scope.reloadDataBlock;
					$ctrl.widget.showAddColumn = scope.showAddColumn;
					$ctrl.widgetData.reload = scope.reload;

					scope.currentExecutionWidget = $ctrl.widget;
					$ctrl.init();
					if ($ctrl.autoExecute) {
						scope.reloadDataBlock();
					}
					$(document).on('click', '.dropdown-menu-summary', function (e) {
						e.stopPropagation();
					});
				},
			};
		},
	])
	.filter('splice', function () {
		// Show dots after long libs
		return function (value, max) {
			if (value == undefined) {
				return '';
			}
			max = parseInt(max, 10);
			if (max == undefined || max < 0) {
				return value;
			}
			max = max / 8;
			if (value.length <= max) {
				return value;
			}
			value = value + '';
			value = value.substr(0, max * 0.85);

			return value + '...';
		};
	});
